module.exports = __webpack_public_path__ + "static/media/logout.40a54cad.svg";